/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import 'react-multi-date-picker/styles/colors/yellow.css';
import logo from '../../assets/hollywood-logo.png';
import './nav.css';

function NavBar() {
    return (
        <>
            <div className="nav-container">
                <div className="nav-content">
                    <img src={logo} alt="logo" width="220px" />
                    <h1 className="dashboard-heading">Market Lenz DASHBOARD</h1>
                </div>
            </div>
            <div style={{ width: '100%', height: '15px', background: '#BA1617' }} />
            <div style={{ width: '100%', height: '8px', background: 'white' }} />
        </>
    );
}

export default NavBar;
